import { ReactNode } from "react";
import { useGetContactInfo } from "api/initial/useGetContactInfo";
import { useGetContactIdData } from "providers/ContactIdProvider";
import { NoPortfolios } from "./components/NoPortfolios";

interface PortfolioGuardProps {
  children: ReactNode;
}

export const PortfolioGuard = ({ children }: PortfolioGuardProps) => {
  const { selectedContactId } = useGetContactIdData();
  const { data: { portfolios } = { portfolios: [] } } = useGetContactInfo(
    false,
    selectedContactId
  );

  if (portfolios.length === 0) {
    return <NoPortfolios />;
  }

  return <>{children}</>;
};
